import { SHOW_NOTIFICATION } from './actionType'

export const initialState = {
  isShown: false,
  message: '',
  duration: 0,
  variant: 'info',
}

export default function notificationReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_NOTIFICATION: {
      const { payload } = action
      const { isShown, message, duration, variant } = payload
      const newState = {
        ...state,
        isShown,
        message,
        duration,
        variant,
      }
      return newState
    }
    default:
      return state
  }
}
